import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useProjectDataContext } from 'domain/shared/newProject';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { Link } from 'react-router-dom';
import { useStaffingProjectUrl } from 'domain/shared/project';
import { STAFFING_DASHBOARD_PATH } from 'domain/shared/core/sharedRouteConstants';

const AssignmentConfirmationBreadcrumbs = () => {
  const { data: project } = useProjectDataContext();
  const { getStaffingProjectUrl } = useStaffingProjectUrl();

  return (
    <Breadcrumbs>
      <Link to={STAFFING_DASHBOARD_PATH}>← Dashboard</Link>
      <ListBreadcrumbItem entity={project.name || EMPTY_VALUE_INDICATOR} link={getStaffingProjectUrl(project.id)} />
      <ListBreadcrumbItem entity="Confirm assignment" />
    </Breadcrumbs>
  );
};

export default AssignmentConfirmationBreadcrumbs;
